import {CommonRootState} from '../types';

export const selectAlert = (state: CommonRootState) =>
  state.uiInteraction.alert;

export const selectUpgradeRequired = (state: CommonRootState) =>
  state.uiInteraction.upgradeRequired;
